export const SET_PLANS = '@@globalUI/SET_PLANS';
export const SET_LOADING = '@@globalUI/SET_LOADING';
export const SET_YEARLY_PLAN = '@@globalUI/SET_YEARLY_PLAN';
